export default __webpack_public_path__ + "static/media/2.eb8a418b.png";